import { Link } from "react-router-dom";
import { Box, Camera, MousePointer2, Layers } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const POINTS = [
  { icon: Layers, text: "Pick any board, stone and handle from the catalogue" },
  { icon: MousePointer2, text: "Orbit and zoom a photo-real kitchen run in real time" },
  { icon: Camera, text: "Save the view, share it, or attach it to a quote" },
];

export const StudioCTA = () => (
  <Reveal className="relative overflow-hidden border border-[#D4AF37]/25 bg-[#13141C]" data-testid="studio-cta">
    <div className="grid lg:grid-cols-[1fr_1.3fr]">
      <div className="p-8 sm:p-12 lg:p-16 flex flex-col justify-between gap-10">
        <div>
          <Eyebrow>3D Pairing Studio</Eyebrow>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl text-[#F5F3EF] leading-[1]">
            See your kitchen <em className="text-[#E5C158]">before it's built.</em>
          </h2>
          <ul className="mt-8 space-y-4">
            {POINTS.map(({ icon: Icon, text }) => (
              <li key={text} className="flex items-start gap-3 text-[#A09E97]">
                <Icon className="w-4 h-4 mt-1 shrink-0 text-[#D4AF37]" /><span>{text}</span>
              </li>
            ))}
          </ul>
        </div>
        <Link to="/pairing" data-testid="studio-cta-btn"
          className="self-start h-14 inline-flex items-center gap-3 rounded-full bg-[#D4AF37] px-8 text-[#0D0D11] font-medium hover:bg-[#E5C158] transition-colors duration-300">
          <Box className="w-4 h-4" /> Open the 3D Studio
        </Link>
      </div>
      <Link to="/pairing" aria-label="Open the 3D Pairing Studio" className="group relative min-h-[300px] lg:min-h-0 block overflow-hidden" data-testid="studio-cta-image">
        <img src="/studio-preview.jpg" alt="3D render of a kitchen run with oak doors, stone benchtop and brass handles"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1800ms] ease-out group-hover:scale-[1.04]" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#13141C] via-transparent to-transparent hidden lg:block" />
        <div className="absolute left-5 bottom-5 sm:left-8 sm:bottom-8 bg-[#0D0D11]/80 backdrop-blur-md border border-[#D4AF37]/30 px-4 py-3 font-mono-j text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">
          Natural Oak · Taj Whisper · Brushed Gold
        </div>
      </Link>
    </div>
  </Reveal>
);
